import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { BroadcastingBasic } from 'src/app/models/broadcastings-models/broadcasting-basic.model';

@Component({
  selector: 'app-broadcastings-broadcastings-breadcrumb-filter-card',
  templateUrl: './broadcastings-broadcastings-breadcrumb-filter-card.component.html',
  styleUrls: ['./broadcastings-broadcastings-breadcrumb-filter-card.component.scss']
})
export class BroadcastingsBroadcastingsBreadcrumbFilterCardComponent implements OnInit {

  @Input() broadcastings;
  statuses;
  statusesForm = new FormGroup({});

  constructor(private broadcastingsService: BroadcastingsService,
              private userStorageService: UserStorageService) { }

  ngOnInit() {
    this.getStatuses();
    if (this.userStorageService.getFilterBroadcastings()) {
      this.statusesForm.patchValue(this.userStorageService.getFilterBroadcastings()['statusesForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterBroadcastings({ statusesForm: this.statusesForm.getRawValue() });
    if (this.userStorageService.getFilterBroadcastings()['statusesForm']['all']) {
      this.userStorageService.deleteFilterDevices();
    }
    this.filter();
  }

  private getStatuses() {
    const statuses = new Array<string>();
    this.statusesForm.addControl('all', new FormControl(true));
    this.broadcastings.forEach((d: BroadcastingBasic) => {
      if (statuses.indexOf(d.Active.toString()) === -1) {
        statuses.push(d.Active.toString());
        this.statusesForm.addControl(d.Active.toString(), new FormControl(false));
      }
    });
    this.statuses = statuses;
  }

  public filter() {
    const forms = {
      statusesForm:
      {
        attribute: 'Status',
        values: []
      }
    };
    if (this.statusesForm.get('all').value) {
      forms['statusesForm'].values = Object.keys(this.statusesForm.value).splice(1);
    } else {
      Object.entries(this.statusesForm.value).map(c => { if (c[1]) { forms['statusesForm'].values.push(c[0]); }});
    }
    this.broadcastingsService.filterBroadcastings(forms);
  }
}
